import { ReactElement, useState } from 'react';
import AlertRuleRow from './AlertRuleRow';
import { ActionData, AlertRule } from '../../constants/telosair-interfaces';

type UsersTableComponentProps = {
  alertRulesArray: AlertRule[];
  handleAction: (data: ActionData<AlertRule>) => void;
};

/**
 * A Users Table Component.
 * @param props - Users Table Component Props.
 * @returns - A React Component.
 */
export default function AlertRulesTable(props: UsersTableComponentProps): ReactElement {
  const { alertRulesArray, handleAction } = props;
  const [sortAscending, setSortAscending] = useState(true);

  return (
    <div>
      <div className="rounded bg-white dark:bg-container-700 text-gray-400 dark:text-gray-400 text-sm font-medium border-b border-b-gray-300 dark:border-b-gray-900">
        <table className="w-full">
          <thead>
            <tr className="w-full text-gray-400 text-xs font-medium">
              <th className="px-6 py-3 flex items-center">
                Rule ID
                <button
                  type="button"
                  className="material-icons-outlined text-sm  pl-1 cursor-pointer"
                  onClick={() => setSortAscending((prevSort) => !prevSort)}
                >
                  {sortAscending ? 'arrow_downward' : 'arrow_upward'}
                </button>
              </th>
              <th className="text-center">Status</th>
              <th className="text-center">Device/Group</th>
              <th className="text-center">Priority</th>
              <th className="text-center">Parameter</th>
              <th className="text-center">Created by</th>
              <th className="text-center">Action</th>
            </tr>
          </thead>
          <tbody>
            {alertRulesArray.map((rule: AlertRule) => (
              <AlertRuleRow key={rule.id} alertRule={rule} handleAction={handleAction} />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
